export default __webpack_public_path__ + "static/media/powerbtn.9079923b.png";